import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  AppContext,
  SET_DEVICE_BP_LIST,
  SET_DEVICE_BS_LIST,
} from "../../../components/AppProvider";
import { PostApi1960, PostApi1961, PostApiDvcList } from "../../../modules/network/padoPost";
import { getCookie, setCookie } from "../../../modules/utils/cookie";

export default props => {
  const { userinfo, phonecfg, cfg, dispatch, dvcBpInfo, dvcBsInfo } =
    useContext(AppContext);
  // 입력팝업.기기입력
  const [isDisplay, setIsDisplay] = useState(false);
  const [isManualDisplay, setIsManualDisplay] = useState(false);
  const [userDvcInfo, setUserDvcInfo] = useState({});
  const [selectFactory, setSelectFactory] = useState({});
  const [selectModel, setSelectModel] = useState({});
  const [drawFactorys, setDrawFactorys] = useState([]);
  const [drawModels, setDrawModels] = useState([]);

  const [dvcTitle, setDvcTitle] = useState("");
  const [inputType, setInputType] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [deviceListOn, setDeviceListOn] = useState(false);
  const [modelListOn, setModelListOn] = useState(false);

  // 장비 목록 조회 (혈압,혈당장비)
  const requestDvcList = dvcType => {
    PostApiDvcList(phonecfg, cfg, dvcType)
      .then(res => {
        if (res.resultMsg === "SUCC") {
          {
            if (dvcType == "BP") {
              dispatch({ type: SET_DEVICE_BP_LIST, data: res.result });
            } else {
              dispatch({ type: SET_DEVICE_BS_LIST, data: res.result });
            }
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // 기기 등록 조회 (혈압,혈당장비) - 사용자 등록
  const requestDvcRegist = dvcType => {
    PostApi1960(userinfo, phonecfg, cfg, dvcType)
      .then(res => {
        if (res.resultMsg === "SUCC") {
          setUserDvcInfo({
            typy: res.result.mnType,
            addType: res.result.dvcAddType,
            ftrCode: res.result.mnftrCd,
            ftrNm: res.result.mnftrNm,
            modelCode: res.result.modelCd,
            modelNm: res.result.modelNm,
            cDate: res.result.cDate,
          });

          setSelectFactory({
            code: res.result.mnftrCd,
            name: res.result.mnftrNm,
          });
          setSelectModel({
            code: res.result.modelCd,
            name: res.result.modelNm,
          });

          props.setDvcTitle(
            res.result.mnftrNm
              ? res.result.mnftrNm + " / " + res.result.modelNm
              : ""
          );
          setInputType(res.result.dvcAddType);

          let toDay = new Date();

          if (res.result.mnftrCd == "") {
            if (dvcType == "BP") {
              if (!getCookie("dvcBpInputDate")) {
                props.setIsDisplay(true);
              } else {
                let pastDay = new Date(getCookie("dvcBpInputDate"));
                let remainingTime = Math.ceil(
                  (toDay - pastDay) / (24 * 60 * 60 * 1000)
                );
                if (remainingTime >= 7) {
                  props.setIsDisplay(true);
                }
              }
            } else {
              if (!getCookie("dvcBsInputDate")) {
                props.setIsDisplay(true);
              } else {
                let pastDay = new Date(getCookie("dvcBsInputDate"));
                let remainingTime = Math.ceil(
                  (toDay - pastDay) / (24 * 60 * 60 * 1000)
                );
                if (remainingTime >= 7) {
                  props.setIsDisplay(true);
                }
              }
            }
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onCloseHandler = () => {
    setSelectFactory({
      code: userDvcInfo.ftrCode,
      name: userDvcInfo.ftrNm,
    });
    setSelectModel({
      code: userDvcInfo.modelCode,
      name: userDvcInfo.modelNm,
    });
    setInputType(userDvcInfo.addType);
    setErrorMsg("");
    let toDay = new Date();
    if (userDvcInfo.ftrCode == "") {
      if (props.type == "BP") {
        setCookie("dvcBpInputDate", toDay, 365);
      } else {
        setCookie("dvcBsInputDate", toDay, 365);
      }
    }

    document.getElementsByTagName("body")[0].classList.remove("scrollLock");
    props.setIsDisplay(false);
  };

  const onSetHandler = () => {
    if (!selectFactory.code || !selectModel.code) {
      if (inputType == "C") {
        setErrorMsg("선택되지 않은 항목이 있습니다");
      } else {
        setErrorMsg("입력되지 않은 항목이 있습니다");
      }
    } else {
      PostApi1961(
        userinfo,
        cfg,
        phonecfg,
        userDvcInfo.ftrCode ? "U" : "I",
        props.type,
        inputType,
        selectFactory.code,
        selectModel.code
      )
        .then(res => {
          if (res.resultMsg === "SUCC") {
            {
              inputType == "C"
                ? props.setDvcTitle(
                    selectFactory.name + " / " + selectModel.name
                  )
                : props.setDvcTitle(
                    selectFactory.code + " / " + selectModel.code
                  );
              setUserDvcInfo({
                typy: props.type,
                addType: inputType,
                ftrCode: selectFactory.code,
                ftrNm: selectFactory.name,
                modelCode: selectModel.code,
                modelNm: selectModel.name,
                cDate: "",
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
      props.setIsDisplay(false);
      document.getElementsByTagName("body")[0].classList.remove("scrollLock");
      setErrorMsg("");
    }
  };

  useEffect(() => {
    if (props.type == "BP") {
      if (dvcBpInfo) {
        setDrawFactorys(
          dvcBpInfo.filter(function (data, index) {
            if (data.dvcType == "BP") {
              return true;
            }
          })
        );
      }
    } else {
      if (dvcBsInfo) {
        setDrawFactorys(
          dvcBsInfo.filter(function (data, index) {
            if (data.dvcType == "BS") {
              return true;
            }
          })
        );
      }
    }

    setDrawModels(
      drawFactorys.filter(function (data, index) {
        if (data.modelCd == selectFactory.code) {
          return true;
        }
      })
    );

    setSelectFactory({
      code: userDvcInfo.ftrCode,
      name: userDvcInfo.ftrNm,
    });

    setSelectModel({
      code: userDvcInfo.modelCode,
      name: userDvcInfo.modelNm,
    });
  }, [dvcBpInfo, dvcBsInfo]);

  useEffect(() => {
    setDrawModels(
      drawFactorys.filter(function (data, index) {
        if (data.modelCd == selectFactory.code) {
          return true;
        }
      })
    );
  }, [selectFactory]);

  // 화면 그리기 전 호출
  useEffect(() => {
    requestDvcRegist(props.type);
    if (dvcBpInfo.length < 1) {
      // 혈압 기기 목록이 없을 경우
      requestDvcList(props.type);
    }

    if (dvcBsInfo.length < 1) {
      // 혈당 기기 목록이 없을 경우
      requestDvcList(props.type);
    }
  }, []);

  return (
    <div className="blacklayer-container" style={{ display: "block" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">{props.typeNm} 측정기 등록</div>
          <div style={{ height: "10px" }}></div>
          <div style={{ display: "flex" }}>
            <div className="under-txt">사용중인 측정기를 선택하세요</div>
            <div
              style={{
                textAlign: "right",
                marginLeft: "auto",
                fontSize: "10px",
                lineHeight: "21px",
              }}>
              <font color="red">{errorMsg}</font>
            </div>
          </div>
          <div className="select-input">
            <div>
              <div
                className={`select-custom-box bfaf-select ${
                  deviceListOn ? "on" : ""
                }`}
                id="factory"
                style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                <a
                  className="btn-select"
                  onClick={e => {
                    // $(e.target).parent().toggleClass("on");
                    setDeviceListOn(!deviceListOn);
                    // $("#model").removeClass("on");
                    modelListOn && setModelListOn(false);
                  }}>
                  {inputType == "E"
                    ? "기타 (직접입력)"
                    : selectFactory.code != ""
                    ? selectFactory.name
                    : "제조사"}
                </a>
                <ul
                  style={{
                    maxHeight: "160px",
                    overflow: "auto",
                    top: "52px",
                  }}>
                  {props.type === "BP"
                    ? dvcBpInfo.map((m, i) => (
                        <DvcInfo
                          key={"idx" + i}
                          m={m}
                          setSelectFactory={setSelectFactory}
                          setSelectModel={setSelectModel}
                          setInputType={setInputType}
                          setErrorMsg={setErrorMsg}
                          deviceListOnOff={() => setDeviceListOn(!deviceListOn)}
                        />
                      ))
                    : dvcBsInfo.map((m, i) => (
                        <DvcInfo
                          key={"idx" + i}
                          m={m}
                          setSelectFactory={setSelectFactory}
                          setSelectModel={setSelectModel}
                          setInputType={setInputType}
                          setErrorMsg={setErrorMsg}
                          deviceListOnOff={() => setDeviceListOn(!deviceListOn)}
                        />
                      ))}
                  <DvcInfoEtc
                    setInputType={setInputType}
                    setSelectFactory={setSelectFactory}
                    setSelectModel={setSelectModel}
                    setErrorMsg={setErrorMsg}
                    selectFactory={selectFactory}
                    reset={true}
                    deviceListOnOff={() => setDeviceListOn(!deviceListOn)}
                  />
                </ul>
              </div>
            </div>
            {inputType === "E" ? (
              <Fragment>
                <div
                  className="inp-with-unit"
                  style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                  <input
                    type="text"
                    className="textbox datetime-picker-input pick-result"
                    style={{
                      height: "46px",
                      lineHeight: "54px",
                      fontSize: "0.9rem",
                    }}
                    placeholder="제조사를 입력하세요"
                    maxLength={30}
                    onBlur={e => {
                      setSelectFactory({
                        code: e.target.value,
                        name: "",
                      });
                    }}
                    defaultValue={selectFactory.code}
                  />
                </div>
                <div
                  className="inp-with-unit"
                  style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                  <input
                    type="text"
                    className="textbox datetime-picker-input pick-result"
                    style={{
                      height: "46px",
                      lineHeight: "54px",
                      fontSize: "0.9rem",
                    }}
                    placeholder="모델명을 입력하세요"
                    maxLength={30}
                    onBlur={e => {
                      setSelectModel({
                        code: e.target.value,
                        name: "",
                      });
                    }}
                    defaultValue={selectModel.code}
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div>
                  <div
                    className={`select-custom-box bfaf-select ${
                      modelListOn ? "on" : ""
                    }`}
                    id="model"
                    style={{ paddingBottom: "10px" }}>
                    <a
                      href={void 0}
                      className="btn-select"
                      onClick={e => {
                        selectFactory.code != "" &&
                          // $(e.target).parent().toggleClass("on");
                          setModelListOn(!modelListOn);
                        selectFactory.code != "" &&
                          // $("#factory").removeClass("on");
                          setDeviceListOn(false);
                      }}>
                      {selectModel.code ? selectModel.name : "모델명"}
                    </a>
                    <ul style={{ maxHeight: "160px", overflowY: "auto" }}>
                      {drawModels.length > 0 &&
                        drawModels[0].modelInfo.map((m, i) => (
                          <li key={m.modelCd}>
                            <a
                              onClick={e => {
                                // $(e.target)
                                //   .closest(".select-custom-box")
                                //   .removeClass("on");
                                modelListOn && setModelListOn(false);

                                // $(e.target)
                                //   .closest(".select-custom-box")
                                //   .find("a.btn-select")
                                //   .html($(e.target).html());

                                setSelectModel({
                                  code: m.modelCd,
                                  name: m.modelNm,
                                });
                              }}>
                              {m.modelNm}
                            </a>
                          </li>
                        ))}

                      <DvcInfoEtc
                        setInputType={setInputType}
                        setSelectFactory={setSelectFactory}
                        setSelectModel={setSelectModel}
                        setErrorMsg={setErrorMsg}
                        selectFactory={selectFactory}
                        reset={false}
                        deviceListOnOff={() => setModelListOn(!modelListOn)}
                      />
                    </ul>
                  </div>
                </div>
              </Fragment>
            )}

            <div className="tbns-area">
              <a
                href={void 0}
                className="btn-round gray"
                onClick={onCloseHandler}>
                취소
              </a>
              <a className="btn-round wht" onClick={() => onSetHandler()}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DvcInfo = props => {
  const {
    m,
    setSelectFactory,
    setSelectModel,
    setInputType,
    setErrorMsg,
    deviceListOnOff,
  } = props;
  return (
    <li>
      <a
        onClick={e => {
          // $(e.target).closest(".select-custom-box").removeClass("on");
          deviceListOnOff();
          // $(e.target)
          //   .closest(".select-custom-box")
          //   .find("a.btn-select")
          //   .html($(e.target).html());
          setSelectFactory({
            code: m.modelCd,
            name: m.modelNm,
          });
          setSelectModel({});
          setInputType("C");
          // if (true) {
          //   $("#model")
          //     .closest(".select-custom-box")
          //     .find("a.btn-select")
          //     .html("모델명");
          // }
          setErrorMsg("");
        }}>
        {m.modelNm}
      </a>
    </li>
  );
};

const DvcInfoEtc = props => {
  const {
    setInputType,
    setSelectFactory,
    setSelectModel,
    setErrorMsg,
    selectFactory,
    reset,
    deviceListOnOff,
  } = props;
  return (
    <li>
      <a
        onClick={e => {
          deviceListOnOff();
          // $(e.target)
          //   .closest(".select-custom-box")
          //   .find("a.btn-select")
          //   .html($(e.target).html());
          setInputType("E");
          setSelectFactory(
            reset
              ? {
                  code: "",
                  name: "",
                }
              : {
                  code: selectFactory.name,
                  name: "",
                }
          );
          setSelectModel({
            code: "",
            name: "",
          });
          setErrorMsg("");
        }}>
        기타 (직접입력)
      </a>
    </li>
  );
};
